import type { ChipProps } from "@mui/material";
import {
	type LucideIcon,
	TrendingDownIcon,
	TrendingUpIcon,
} from "lucide-react";
import {
	NBSP,
	roundNumber,
	signedNumberFormatter,
} from "web_myplann/Shared/Utils/numberFormatters";

const PERCENT_DECIMAL_PLACES = 1;

type TrendChipProps = {
	color: ChipProps["color"];
	Icon: LucideIcon | null;
	label: string;
};

const TREND = {
	positive: { color: "success", Icon: TrendingUpIcon },
	negative: { color: "error", Icon: TrendingDownIcon },
	zero: { color: "default", Icon: null },
} as const satisfies Record<
	"positive" | "negative" | "zero",
	Omit<TrendChipProps, "label">
>;

export const getTrendChipProps = (
	percent: number | null | undefined,
): TrendChipProps | null => {
	if (percent === null || percent === undefined) {
		return null;
	}

	const rounded = roundNumber(percent, PERCENT_DECIMAL_PLACES);
	const { color, Icon } =
		rounded === 0 ? TREND.zero : rounded > 0 ? TREND.positive : TREND.negative;

	return {
		color,
		Icon,
		label: `${signedNumberFormatter.format(rounded)}${NBSP}%`,
	};
};
